import React from "react";
import styled from "styled-components";

import { Flex } from "../../../components/Flex";
import { Text } from "../../../components/Text";
import { Entry } from "../../../model/entry/Entry";
import { Spacing } from "../../../theme/Spacing";
import { DuplicateEntryFieldDescriptor } from "../utils/duplicateEntryFields";

const MetaRow = styled(Flex)`
  flex-wrap: wrap;
  align-items: center;
  column-gap: ${Spacing.l};
  row-gap: ${Spacing.xs};
`;

const MetaItem = styled(Flex)`
  align-items: center;
  gap: ${Spacing.xs};
`;

type Props = {
  entry: Entry;
  descriptors: DuplicateEntryFieldDescriptor[];
};

export const EntryMetaStrip: React.FC<Props> = ({ entry, descriptors }) => {
  const items = descriptors
    .filter((descriptor) => !descriptor.actionable)
    .map((descriptor) => ({
      descriptor,
      content: descriptor.renderReadOnly(entry),
    }))
    .filter(({ content }) => content !== null && content !== undefined);

  if (!items.length) {
    return null;
  }

  return (
    <MetaRow>
      {items.map(({ descriptor, content }) => (
        <MetaItem key={descriptor.key}>
          <Text fontSize="xs" color="darkerSub">
            {descriptor.label}:
          </Text>
          {content}
        </MetaItem>
      ))}
    </MetaRow>
  );
};
